<div class="page gray-font-color font-family employment-history">
  <div class="header-navigation-back">
    <mat-icon (click)="goBack()" data-test="back-arrow-icon" data-testid="back-arrow-icon">arrow_back</mat-icon>
    <span class="title" data-test="edit-button">Employment History</span>
  </div>
  <div>
    @if (errorMessage) {
      <mat-error class="error padding-left-md">
        {{ errorMessage }}
      </mat-error>
    }
  </div>
  @if (!isContentReady) {
    <app-skeleton-emp-residence-history
      isResidenceHistory="false"
    ></app-skeleton-emp-residence-history>
  }
  @if (isContentReady) {
    <div>
      <div [ngClass]="canShowAddButton ? 'content' : 'content-overflow'">

        <!-- ── SCENARIO 5: Stale employer inline banner (replaces bottom sheet) ── -->
        @if (showStaleEmployerBanner) {
          <div class="stale-employer-banner">
            <mat-icon class="stale-icon">access_time</mat-icon>
            <div class="stale-content">
              <span class="stale-question">Still working at <strong>{{ currentEmployerName }}</strong>?</span>
              <div class="stale-actions">
                <button class="stale-btn stale-btn-yes" (click)="onStaleConfirmYes()">Yes, still here</button>
                <button class="stale-btn stale-btn-no" (click)="onStaleConfirmNo()">No, I left</button>
              </div>
            </div>
          </div>
        }

        <!-- ── SCENARIO 6: Missing current employer — red warning + dashed CTA ── -->
        @if (showAddNewCurrentRecordText) {
          <div class="missing-current-banner">
            <mat-icon>warning</mat-icon>
            <span>You haven't added your current employer yet. Please add where you work now.</span>
          </div>
          <div class="add-current-cta" [matMenuTriggerFor]="addCurrentMenu">
            <mat-icon>add_circle_outline</mat-icon>
            <div class="add-current-cta-text">
              <span class="add-current-cta-title">Add Current Employer</span>
              <span class="add-current-cta-sub">Required — add where you work today</span>
            </div>
          </div>
          <mat-menu #addCurrentMenu="matMenu" class="button-menu-container" xPosition="after">
            <button mat-menu-item (click)="onAddNewCurrentEmployment(true)" class="menu-button">
              Employment Period
            </button>
            <button mat-menu-item (click)="onAddNewCurrentEmployment(false)" class="menu-button">
              Unemployment Period
            </button>
          </mat-menu>
        }

        <!-- ── SCENARIO 4: Complete ── SCENARIO 1/2/3: In-progress banner ── -->
        @if (!showAddNewCurrentRecordText) {
          @if (driver.employmentRequirementsCompleted) {
            <!-- Scenario 4: green success banner -->
            <div class="description-banner complete-banner">
              <mat-icon class="complete-banner-icon">check_circle</mat-icon>
              <span>Your employment details for the <strong>last 10 years</strong> are complete!</span>
            </div>
          } @else {
            <!-- Scenario 1 / 2 / 3: still filling in -->
            <div class="description-banner">
              <div class="description">
                <span class="light-font-weight">Please provide your employment for the </span>
                <span class="bold-text">last 10 years</span><span class="light-font-weight">, without any gaps.</span>
              </div>
            </div>
          }
        }

        <!-- ── Progress bar ── -->
        <div class="progress-bar-container">
          <mat-progress-bar mode="determinate" [value]="progressBarValue"></mat-progress-bar>
        </div>
        <div class="progress-bar-text">
          <div class="past-date-text bold-text">{{ lastMonthYear }}</div>
          <div class="current-date-text bold-text">{{ currentMonthYear }}</div>
        </div>

        <!-- ── SCENARIO 1: Empty state ── -->
        @if (employmentList?.length === 0) {
          <div class="empty-state">
            <mat-icon class="empty-icon">work_outline</mat-icon>
            <div class="empty-title">No employment records yet</div>
            <div class="empty-sub">Start by adding where you currently work</div>
          </div>
        }

        <!-- ── SCENARIO 2 / 3 / 4: Records list ── -->
        @if (employmentList?.length > 0) {
          <div class="app-employment-view">
            @for (employment of employmentList; track employment; let index = $index) {
              <div>
                <app-employment-view
                  [isOnlyCurrentEmployment]="isOnlyCurrentEmployment(employmentList)"
                  [model]="employment"
                  [index]="index"
                  [needsMandatoryFieldsCompletion]="employmentRecordNeedsAttention(employment)"
                  [prevModel]="employmentList[index - 1]"
                  [nextModel]="employmentList[index + 1]"
                  (updateEmploymentPressed)="onUpdateEmploymentPressed($event)"
                  (deleteEmploymentPressed)="onDeleteEmploymentPressed($event)"
                  (openEmploymentFormPressed)="onAddNewEmployment($event)"
                  (openUnEmploymentFormPressed)="onAddUnemployment($event)"
                  class="app-employment-view"
                ></app-employment-view>
              </div>
            }
          </div>
        }
      </div>

      <!-- ── Add button (hidden when fully complete) ── -->
      @if (canShowAddButton) {
        <div class="add-new-container">
          <button mat-button [matMenuTriggerFor]="menu" class="btn-add" data-testid="addEmployment-record">
            <i class="material-icons" data-test="add-new-record">add</i>
            {{ employmentList?.length === 0 ? 'Add Employment Record' : 'Add Previous Record' }}
          </button>
          <mat-menu #menu="matMenu" class="button-menu-container" xPosition="after">
            <button mat-menu-item (click)="onAddNewEmployment(undefined)" class="menu-button"
              data-testid="employment-period" data-test="employment-period">
              Employment Period
            </button>
            <button mat-menu-item (click)="onAddUnemployment(undefined)" class="menu-button"
              data-testid="unemployment-period" data-test="unemployment-period">
              Unemployment Period
            </button>
          </mat-menu>
        </div>
      }
    </div>
  }
</div>
